import Api from '@/http/api'
import wx from 'weixin-js-sdk'
import { isIos } from '@/utils/help'
import store from '@/store'
const LOG_TAG = '【微信jssdk】'
const wxJsSdk = {
  defaultContent: {
    title: 'DSHUI领券专区',
    desc:
      '专业的质优价廉网上购物商城,化妆用品、香水彩妆、女性护理、家具家纺、服装服饰、潮流鞋子、洗发护发、身体护理、玩具乐器、面部护理、食品等数万个品牌产品的汇聚地',
    imgUrl: 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/wx_share/share.jpg',
  },
  config: function(callbackFunc) {
    // 配置
    let jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareQQ', 'onMenuShareQZone', 'onMenuShareWeibo', 'previewImage']
    let pageUrl = isIos() ? store.state.jsUrl.split('#')[0] : location.href.split('#')[0]
    Api.common.loadWxShare(encodeURIComponent(pageUrl))
      .then(res => {
        if (res.code === 1) {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: jsApiList,
          })
          if (callbackFunc) {
            // 回调
            callbackFunc()
          }
        }
        wx.error(function(res) {
          console.log(`${LOG_TAG} 配置 验证失败error`, res)
        })
      })
      .catch(error => {
        console.log(`${LOG_TAG} 配置 异常错误error`, error)
      })
  },
  ready(shareObj) {
    const shareContent = {
      title: shareObj.title || this.defaultContent.title,
      desc: shareObj.desc || this.defaultContent.desc,
      imgUrl: shareObj.imgUrl || this.defaultContent.imgUrl,
      link: shareObj.link || location.href.split('#')[0],
    }
    wx.ready(function() {
      console.log(LOG_TAG, '调用wx ready方法')
      wx.updateAppMessageShareData(shareContent) // 自定义“分享给朋友”及“分享到QQ”按钮
      wx.updateTimelineShareData(shareContent) // 自定义“分享到朋友圈”及“分享到QQ空间”按钮
    })
  },
}
export default wxJsSdk
